import { deviceSeriesKeys } from '@utils/aiAlerts/mapping';

export const AI_ALERT_EVENTS = 'ai-alert-events';
export const AI_ALERT_PCP = 'ai-alert-pcp';
export const AI_ALERT_MARKERS = 'ai-alert-markers';

export const DEVICE_AXIS = 'device-value-axis';
export const PCP_AXIS = 'pcp-value-axis';


export const AiAlertSeriesKeys = [
  AI_ALERT_EVENTS,
  'ai-alert-timeseries',
  'ai-alert-threshold',
  'ai-alert-baseline',
  'ai-alert-tMinus7',
  AI_ALERT_PCP,
  ...deviceSeriesKeys,
];
